import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-2017"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M0 11.77s5.837-.185 6.688-3.165c.834-2.919-2.461-4.063-4.144-3.39-1.309.524-1.408 1.551-1.305 1.851 0 0 2.976-1.199 3.365 1.048C5.01 10.463 0 11.77 0 11.77z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M12.14 3.972c-1.375-3.316-6.282-.756-6.282-.756s4.48-.842 4.294 2.597S4.056 12.111.626 13.01c0 0 5.545-.449 8.377-2.458 2.831-2.008 4.017-4.456 3.137-6.58z" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", { d: "M15.975 5.825c-.33-3.664-4.08-3.806-4.08-3.806s4.332 3.607.571 7.584c-4.179 4.42-11.267 3.971-11.005 4.049 1.927.57 7.005.485 9.877-.941 2.723-1.352 4.92-3.754 4.637-6.886z" }, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }